<template>
  <div>
    <userroles
      :userroles="userRoles"
      :usergroups="userGroups"
      :modulesubmodules="moduleSubmodules"
      @userRoleChange="getUserRoles()"
    ></userroles>
  </div>
</template>

<script>
import Api from "@/services/Api";
import UserRoles from "@/components/UserRoles.vue";

export default {
  components: {
    userroles: UserRoles
  },
  data() {
    return {
      userRoles: [],
      userGroups: [],
      moduleSubmodules: []
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
        this.getUserRoles();
        this.getUserGroups();
        this.getModuleSubmodules();
      
    },
    getUserRoles() {
      Api()
        .get("/userRole")
        .then(response => {
          this.userRoles = response.data;
        });
    },
    getUserGroups() {
      Api()
        .get("/userGroup")
        .then(response => {
          this.userGroups = response.data;
        });
    },
    getModuleSubmodules() {
      Api()
        .get("/moduleSubmodule")
        .then(response => {
          this.moduleSubmodules = response.data;
        });
    }
  }
};
</script>

<style>
</style>